import { NaniumObject, RequestType } from 'nanium/objects';
import { ServiceRequestBase } from '../../serviceRequestBase';
import { Facility } from "../../../entities/facility.entity";

export class FacilityPictureQueryRequestBody extends NaniumObject<FacilityPictureQueryRequestBody> {
}

@RequestType({
	responseType: Array,
	genericTypes: { TRequestBody: FacilityPictureQueryRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class FacilityPictureQueryRequest extends ServiceRequestBase<FacilityPictureQueryRequestBody, Facility[]> {
	static serviceName: string = 'NaniumDemo:facility/Picture/query';
}
